import { CONSTANTS } from '@/utils';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    fallbackLng: CONSTANTS.LANGUAGES.INDONESIAN,
    supportedLngs: [CONSTANTS.LANGUAGES.INDONESIAN, CONSTANTS.LANGUAGES.ENGLISH],
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
